// library imports
import * as React from "react";
import { Grid, Link, Stack } from "@mui/material";
import { AuthenticationContext } from "../Context";
import { useHistory } from "react-router-dom";
import { useCustomerPermission } from "../hooks/useCustomerPermission";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const ReportIndex: React.FC = () => {
  const { currentUser, ..._ } = React.useContext(AuthenticationContext);
  const history = useHistory();

  const { permitted: useOneProgramPermitted } =
    useCustomerPermission("Use ONE Program");

  return (
    <div className="patient-index-container">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="container"
      >
        <Grid item xs={12} md={12}>
          <div className="userAdminInformation">
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="stretch"
              className="adminHeader"
            >
              <Grid item xs={12} md={6}>
                <Stack direction="row" columnGap="12px">
                  <Link
                    style={{
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                    }}
                    href={`/settings`}
                  >
                    <ArrowBackIosNewIcon
                      style={{
                        borderRadius: "3px",
                        padding: "8px",
                        color: "black",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        fontSize: "14px",
                      }}
                    />
                  </Link>
                  <h3>Reports</h3>
                </Stack>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="divider"></div>
        </Grid>
        <Grid item xs={12} className="admin-report">
          <div className="admin-report--container">
            <Grid container columnGap="34px">
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/adt-discharge-report")}
              >
                <div className="report-card__header">ADT Discharge</div>
                <div className="report-card__body">
                  List of all actions for Discharge events received from NDHIN
                  with optional filtering on Date Range, Organization, Provider,
                  Patient Class, and Action Status.
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/provider-action-report")}
              >
                <div className="report-card__header">Provider Actions</div>
                <div className="report-card__body">
                  List of available actions for your Providers with optional
                  filtering on Date Range, Organization, and Provider.
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/encounter-detail-report")}
              >
                <div className="report-card__header">Encounter Detail</div>
                <div className="report-card__body">
                  This report returns detailed patient encounter and billing
                  information such as date of service, type of visit, CPT and
                  diagnosis codes, insurance, providers, and charges.
                </div>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid
              container
              columnGap="34px"
              style={{ marginTop: 30 }}
            >
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/immunizaiton-forecast-report")}
              >
                <div className="report-card__header">
                  Immunization Forecaster Detail
                </div>
                <div className="report-card__body">
                  List of an individual&apos;s vaccination history and future
                  immunization recommendations. Includes details such as past
                  immunizations, upcoming vaccine schedules, and any potential
                  gaps in vaccination coverage.
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/vax-aggregate-report")}
              >
                <div className="report-card__header">Vax Aggregate Report</div>
                <div className="report-card__body">
                  This report returns data on immunizations forecasted,
                  delivered, and deferred in aggregate by vaccine type (TD, flu,
                  etc) at the organization and county level.
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/patient-demographic-report")}
              >
                <div className="report-card__header">
                  Basic Patient Demographics
                </div>
                <div className="report-card__body">
                  This report returns basic demographic information such as
                  name, address, ethnicity, insurance information, and
                  connectivity to outside data sources such as HIE and IIS
                  systems.
                </div>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid
              container
              columnGap="34px"
              style={{ marginTop: 30 }}
            >
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/diabetes-management-report")}
              >
                <div className="report-card__header">
                  NDPERS Diabetes Program
                </div>
                <div className="report-card__body">
                  Access information surrounding patient outcomes and program
                  effectiveness with reports centered around the NDPERS Diabetes
                  Program.
                </div>
              </Grid>
              {useOneProgramPermitted && (
                <Grid
                  item
                  xs={3}
                  className="report-card"
                  onClick={() => history.push("/one-program-report")}
                >
                  <div className="report-card__header">ONE Program</div>
                  <div className="report-card__body">
                    Access information surrounding patient outcomes and program
                    effectiveness with reports centered around the ONE Program.
                  </div>
                </Grid>
              )}
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/questionnaire-report")}
              >
                <div className="report-card__header">Questionnaire Report</div>
                <div className="report-card__body">
                  View detailed patient responses from completed questionnaires
                  within your organization, including submission dates,
                  participant details, and all associated question data.
                </div>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ReportIndex;
